import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Client } from '../../models/client';
import { MoovConfiguration } from '../../models/moovConfiguration';
import { Clipboard } from '@angular/cdk/clipboard';
import { LocationStrategy } from '@angular/common';

@Component({ standalone:false,
  selector: 'app-external-upload-link-dialog',
  templateUrl: 'external-upload-link-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['external-upload-link-dialog.component.scss']
})
export class ExternalUploadLinkDialogComponent {
  title: string= "Upload Link";
  message: string = "Upload Link";
  confirmButtonText = "Yes";
  cancelButtonText = "Cancel";

  public moovConfiguration!: MoovConfiguration;
  public client!:Client;
  public url!:string;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<ExternalUploadLinkDialogComponent>, private clipboard:Clipboard, private locationStrategy:LocationStrategy) {
    
    if(data){
        this.title=data.title;
        this.message = data.message || this.message;
        if (data.buttonText) {
            this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
            this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
        }
        if(data.moovConfiguration){
          this.moovConfiguration=data.moovConfiguration;
          this.url=window.location.origin+"/external?id="+this.moovConfiguration.uniqueIdentifier;
        }
        if(data.client){
          this.client=data.client;
        }
    }
  }

  onCopyClick(url:string){
    this.clipboard.copy(url);
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
  onCancelClick(): void {
    this.dialogRef.close(false);
  }

}